// Sort an array of staff by the number of residents (visibleHubs) they are linked to.
// When `descending` is true (default), the staff member with the most residents comes first.
export const sortByResidentCount = (users, descending = true) => {
  if (!users) return [];
  return [...users].sort((a, b) => {
    const aCount = a?.visibleHubs?.length ?? 0;
    const bCount = b?.visibleHubs?.length ?? 0;
    return descending ? bCount - aCount : aCount - bCount;
  });
};
